module.exports = __webpack_public_path__ + "img/mark.f0afa525.svg";